<template>
    <div v-if="cart">
        <h3 class="font-weight-bold ml-5 pl-4 text-center">Your cart</h3>
        <div class="mx-5 px-5">
            <div class="row">
                <div class="col-8">
                    <h6 class="text-muted text-uppercase font-weight-bold">Product</h6>
                </div>
                <div class="col-2">
                    <h6 class="text-muted text-uppercase font-weight-bold">Quantity</h6>
                </div>
                <div class="col-2 text-uppercase text-right">
                    <h6 class="text-muted text-uppercase font-weight-bold">Total</h6>
                </div>
            </div>

            <div v-for="item, key in cartItems" :key="key" class="row mt-2 cart-item py-4">
                <div class="col-8 flex-col">
                    <h5>{{ item.name }}</h5>
                    <span v-for="price, priceKey in item.prices" v-if="price.id === item.selectedPriceID">
                        {{ toCurrency(price.unit_amount / 100, price.currency) }}
                    </span>
                    <br />
                    <span v-for="price, priceKey in item.prices" v-if="price.id === item.selectedPriceID">
                        {{ price.nickname }}
                    </span>
                </div>
                <div class="col-2">
                    <div>
                        <div class="input-group d-flex justify-content-between w-50">
                            <span class="input-group-prepend">
                                <button @click="removeItemFromCart(item.selectedPriceID)" type="button"
                                    class="btn btn-outline-secondary btn-number" data-type="minus" data-field="quant[1]">
                                    -
                                </button>
                            </span>
                            <span class="d-flex align-items-center">
                                {{ getCartItemQuantity(item.selectedPriceID) }}
                            </span>
                            <span class="input-group-append">
                                <button @click="addItemToCart(item.selectedPriceID)" type="button"
                                    class="btn btn-outline-secondary btn-number" data-type="plus" data-field="quant[1]">
                                    +
                                </button>
                            </span>
                        </div>

                    </div>
                </div>
                <div class="col-2 text-uppercase text-right">
                    {{ calcuteTotal(item.selectedPriceID) }}
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-end  mx-5 px-5">
            <button @click="createCheckout" type="button" class="w-25 btn btn-dark btn-block btn-lg"
                data-mdb-ripple-color="dark">Checkout</button>
        </div>
    </div>
</template>

<script>
import {
    toCurrency
} from '../utils/currency'
import {
    getUserCart, removeFromCart, addToCart
} from '../services/cart.service'
import {
    createCheckoutSession,
    getPricesByLookupKeys

} from '../services/stripe.service'


export default {
    data() {
        return {
            cart: null,
            username: this.$store.state.apiEvents.username
        }
    },
    methods: {
        toCurrency,
        removeFromCart,
        getCartItemQuantity(selectedPriceID) {
            const qty = this.cart.items.filter(item => item.selectedPriceID === selectedPriceID)
            return qty.length;
        },
        calcuteTotal(selectedPriceID) {

            const product = this.cart.items.find((item) => item.selectedPriceID === selectedPriceID);
            const price = product.prices.find(p => p.id === selectedPriceID)
            const amount = this.getCartItemQuantity(selectedPriceID) * price.unit_amount

            return this.toCurrency(amount / 100, price.currency)
        },
        addItemToCart(selectedPriceID) {
            if (!localStorage.getItem('jwt')) {
                const product = this.cart.items.find(item => item.selectedPriceID === selectedPriceID)
                this.$store.dispatch('cart/addItemToCart', product)
            } else {
                const product = this.cart.items.find(item => item.selectedPriceID === selectedPriceID)
                addToCart(selectedPriceID, product.id)
                    .then(() => {
                        this.loadProducts()
                    })
            }
        },
        loadProducts() {
            getUserCart()
                .then(({ data }) => {
                    if (data) {
                        const uniqueProducts = [...new Set(data.map(item => {
                            return item.product_id
                        }))]

                        const toLoadProducts = uniqueProducts.filter((item) => !this.$store.state.cart.items.map(i => i.id).includes(item))
                        if (toLoadProducts.length > 0) {
                            // Load these products
                            this.cart = {
                                items: data
                            }

                        } else {
                            this.cart = this.$store.state.cart;
                        }

                    }
                })
                .catch((err) => {
                    console.error(err)
                })
        },
        removeItemFromCart(selectedPriceID) {
            if (!localStorage.getItem('jwt')) {
                this.$store.dispatch('cart/removeItemFromCart', selectedPriceID)
            } else {
                // remove from cart endpoint
                this.removeFromCart(selectedPriceID).then(() => {
                    this.loadProducts()
                })
            }
        },
        createCheckout() {
            const line_items = this.cart.items.reduce((acc, curr) => {
                console.log(curr.selectedPriceID);
                if (!acc[curr.selectedPriceID]) {
                    acc = {
                        ...acc,
                        [curr.selectedPriceID]: {
                            price: curr.selectedPriceID,
                            quantity: 1
                        }
                    }
                } else {

                    acc[curr.selectedPriceID].quantity += 1
                }
                return acc;
            }, {})

            let createCheckoutOptions = {
                "line_items": Object.values(line_items),
            }

            if (this.$store.state.apiEvents.username) {
                createCheckoutOptions = {
                    ...createCheckoutOptions,
                    customer_email: this.$store.state.apiEvents.username
                }
            }

            // Call api to add to cart
            createCheckoutSession(createCheckoutOptions)
                .then(({ data: checkoutData }) => {
                    window.location.href = checkoutData.url
                })
                .catch((err) => {
                    // toast error
                })
        },
        lookUpAddToCart() {
            const lookupKeys = this.$route.query.add.split(',');
            getPricesByLookupKeys(lookupKeys)
                .then(({ data }) => {
                    data.forEach((el) => {
                        if (!localStorage.getItem('jwt')) {
                            const { product, ...rest } = el
                            this.$store.dispatch('cart/addItemToCart', {
                                ...product,
                                prices: [rest],
                                selectedPriceID: rest.id
                            })
                        } else {
                            addToCart(el.id, el.product.id)
                                .then(() => {
                                    this.loadProducts()
                                })
                        }
                    })
                })
                .catch(err => {
                    console.error(err)
                    // handle error
                })
                .finally(() => {
                    this.$router.replace({ 'query': null });
                })
        }
    },
    computed: {
        cartItems() {
            return this.cart.items.reduce((acc, curr) => {
                if (!acc.some(item => item.selectedPriceID === curr.selectedPriceID)) {
                    acc.push(curr)
                }
                return acc;
            }, [])
        }
    },
    mounted() {
        if (localStorage.getItem('jwt')) {
            // get cart from api
            this.loadProducts()

        } else {
            this.cart = this.$store.state.cart;
        }

        if (this.$route.query.add) {
            this.lookUpAddToCart()
        }

    }
}
</script>

<style lang="scss" scoped>
.cart-item {
    border-top: 0.5px solid rgba(155, 146, 146, 0.637);
}
</style>